import './catalog.component.scss'

const navigation = document.querySelector('.catalog-navigation')
const categories = document.querySelectorAll('.catalog__category')

const navigationHandler = (event) => {
  const button = event.target.closest('[data-target]')
  if (button) {
    const targetSelector = button.dataset.target
    const targetElement = document.querySelector(targetSelector)

    if (targetElement) {
      const offset =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--header-body-height'
          )
        ) + navigation.getBoundingClientRect().height
      window.scrollTo({
        top:
          targetElement.getBoundingClientRect().top - offset + window.scrollY,
        behavior: 'smooth'
      })
    }
  }
}

if (navigation) {
  navigation.addEventListener('click', navigationHandler)
  const categoriesWeight = new Map()
  const options = {
    threshold: 0.001,
    rootMargin: '-200px 0px -200px 0px'
  }
  const calculateActiveCategory = () => {
    const tagetCategory = Array.from(categoriesWeight)
      .filter((i) => i[1] > 0)
      .sort((a, b) => b[1] - a[1])
      .map((e) => e[0])
      .find((_, i) => i < 1)

    navigation
      .querySelectorAll('button[data-target].is-active')
      .forEach((button) => button.classList.remove('is-active'))
    if (tagetCategory) {
      const targetButton = navigation.querySelector(
        `button[data-target="#${tagetCategory.id}"]`
      )
      if (targetButton) {
        targetButton.classList.add('is-active')
        navigation.querySelector('.catalog-navigation__list').scrollTo({
          left: targetButton.getBoundingClientRect().left,
          behavior: 'smooth'
        })
      }
    }
  }
  const callback = (entries) => {
    entries.forEach((entry) => {
      categoriesWeight.set(
        entry.target,
        entry.isIntersecting ? entry.intersectionRatio : 0
      )
      calculateActiveCategory()
    })
  }
  const observer = new IntersectionObserver(callback, options)
  categories.forEach((category) => {
    categoriesWeight.set(category, 0)
    observer.observe(category)
  })
}
